import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-52feab2c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "misceWrap"
};
var _hoisted_2 = {
  "class": "hisHeader one"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "hisHunt"
  }, [/*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createTextVNode("澳門六合彩 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 開獎公告 ")])], -1);
});
var _hoisted_4 = {
  "class": "hisSearch"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1025 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M1023.426 964.706L808.421 750.061a456.425 456.425 0 1 0-59.024 58.768l215.004 214.749c1.946 1.946 10.24-3.02 18.276-11.16l29.435-29.384c8.242-8.242 13.259-16.38 11.314-18.326zm-565.77-134.171a373.699 373.699 0 1 1 374.467-373.699 374.109 374.109 0 0 1-374.468 373.699z"
  })], -1);
});
var _hoisted_6 = {
  "class": "main-page"
};
var _hoisted_7 = {
  "class": "curtLottery"
};
var _hoisted_8 = {
  "class": "currentGame atlist"
};
var _hoisted_9 = {
  "class": "nextDraw"
};
var _hoisted_10 = {
  "class": "nextDrawInner"
};
var _hoisted_11 = {
  "class": "countdown"
};
var _hoisted_12 = {
  "class": ""
};
var _hoisted_13 = {
  "class": ""
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", {
    "class": "dot"
  }, ":", -1);
});
var _hoisted_15 = {
  "class": ""
};
var _hoisted_16 = {
  "class": ""
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", {
    "class": "dot"
  }, ":", -1);
});
var _hoisted_18 = {
  "class": ""
};
var _hoisted_19 = {
  "class": ""
};
var _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"lotteryActs\" style=\"display:none;\" data-v-52feab2c><div class=\"lotteryBtns\" data-v-52feab2c><button class=\"button-yellow\" data-v-52feab2c> 開獎驗證 </button><button class=\"button-primary\" data-v-52feab2c> 直播 </button><div class=\"lotteryPledge\" style=\"display:none;\" data-v-52feab2c><b data-v-52feab2c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1025 1024\" width=\"1em\" height=\"1em\" fill=\"currentColor\" data-v-52feab2c><path d=\"M512 128a384 384 0 1 1-.043 768.043A384 384 0 0 1 512 128zm-19.2 553.259l76.501-248.363-16-1.408-91.52 11.69-4.693 13.995c3.755.086 6.955.256 9.6.512a17.067 17.067 0 0 1 13.227 7.254c2.986 4.266 4.266 9.088 3.84 14.293-.726 8.277-3.584 20.48-8.534 36.565l-51.754 166.955c-4.182 13.312-6.656 24.277-7.424 33.11-1.152 13.226 1.28 24.533 7.338 33.791a33.28 33.28 0 0 0 26.283 15.403c30.08 2.645 61.099-26.112 93.27-86.23l-8.363-7.935c-13.142 22.016-24.107 37.077-32.854 45.184-3.285 3.328-6.4 4.864-9.429 4.565-1.835-.128-3.413-1.365-4.779-3.797a12.715 12.715 0 0 1-1.706-7.51c.384-4.437 2.688-13.866 6.954-28.074zM554.496 384a41.301 41.301 0 0 0 30.293-12.459 41.301 41.301 0 0 0 12.544-30.208 41.43 41.43 0 0 0-12.373-30.208 41.344 41.344 0 0 0-30.421-12.458 40.96 40.96 0 0 0-30.166 12.458A41.43 41.43 0 0 0 512 341.333c0 11.776 4.139 21.846 12.501 30.208C532.907 379.82 542.848 384 554.54 384z\" data-v-52feab2c></path></svg> 即時開獎驗證</b><p data-v-52feab2c>開獎現場直播，同步播報中央電視臺1套視頻，開獎過程100%公開公正！</p></div></div></div>", 1);
var _hoisted_21 = {
  "class": "currentCode"
};
var _hoisted_22 = {
  "class": "currentCodeInner"
};
var _hoisted_23 = {
  "class": "mhide"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("strong", null, "澳門六合彩", -1);
});
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "開獎號碼 ", -1);
});
var _hoisted_26 = {
  "class": "drawCode big"
};
var _hoisted_27 = {
  "class": "hisHeader tow"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "hisHunt"
  }, [/*#__PURE__*/_createElementVNode("h3", null, "澳門六合彩 開獎公告 ")], -1);
});
var _hoisted_29 = {
  "class": "hisFilter"
};
var _hoisted_30 = {
  "class": "hisSearch"
};
var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1025 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M1023.426 964.706L808.421 750.061a456.425 456.425 0 1 0-59.024 58.768l215.004 214.749c1.946 1.946 10.24-3.02 18.276-11.16l29.435-29.384c8.242-8.242 13.259-16.38 11.314-18.326zm-565.77-134.171a373.699 373.699 0 1 1 374.467-373.699 374.109 374.109 0 0 1-374.468 373.699z"
  })], -1);
});
import hisWrapper from '@/components/hisWrapper.vue';
import { record } from '@/utils/https.js';
import plaues from '@/components/playes.vue';
import { reactive } from 'vue';
import axios from "axios"; //原生的axios

export default {
  __name: 'index',
  setup: function setup(__props) {
    var t = new Date().getTime();
    var tow = function tow(n) {
      return n >= 0 && n < 10 ? '0' + n : '' + n;
    };
    var toLink = reactive([{
      name: '澳門六合彩',
      path: '/post'
    }, {
      name: '接口調用',
      path: '/post/api'
    }
    //  {name:'資料區',path:'/post'},
    ]);

    var videoShow = ref(false);
    var codeArray = reactive({});
    var pclose = function pclose(e) {
      videoShow.value = e;
    };
    var videoBack = function videoBack(e) {
      videoShow.value = true;
      codeArray = e;
    };
    var fiveArray = reactive([]);
    var fivedata = ref([]);
    var newCode = ref({});
    var kajing = reactive([]);
    var period = ref('');
    var hours = ref([0, 0]);
    var minutes = ref([0, 0]);
    var seconds = ref([0, 0]);

    //简体字转繁体字
    var textChange = function textChange(n) {
      var jt = "龙马鸡猪";
      var ft = "龍馬雞豬";
      if (jt.indexOf(n) == -1) {
        return n;
      } else {
        var r = ft.substr(jt.indexOf(n), 1);
        return r;
      }
      return n;
    };
    setInterval(function () {
      getDate();
    }, 1000);
    var getDate = function getDate() {
      var oDate = new Date(); //获取日期对象
      var oldTime = oDate.getTime(); //现在距离1970年的毫秒数
      var tive = newCode.value.Year + '/' + newCode.value.Moon + '/' + newCode.value.Day + ' ' + newCode.value.Time + ':00';
      var newDate = new Date(tive);
      var newTime = newDate.getTime(); //2019年距离1970年的毫秒数
      var second = Math.floor((newTime - oldTime) / 1000); //未来时间距离现在的秒数
      var hour = Math.floor(second / 3600); //整数部分代表小时；
      second %= 3600; //余数代表 剩下的秒数；
      var minute = Math.floor(second / 60);
      second %= 60;
      hours.value = tow(hour).split('');
      minutes.value = tow(minute).split('');
      seconds.value = tow(second).split('');
    };
    onBeforeMount(function () {
      var url1 = "https://kj6.kkjj.finance/data/v_" + process.env.VUE_APP_TYPE_NAME + ".json?" + t;
      axios(url1).then(function (res) {
        var data = res.data;
        data.Time = data.Time.replace('点', ':').replace('分', '');
        for (var i = 1; i <= 7; i++) {
          kajing.push(data.Data[i]);
        }
        newCode.value = data;
      });
      records();
    });
    var activeIndex = ref(1);
    var newYear = function newYear(e) {
      activeIndex.value = e;
      var s = newCode.value.Year - 1 + '/01/01 00:00:00';
      var t = newCode.value.Year - 1 + '/12/31 00:00:00';
      records(s, t, '');
      console.log(s, t);
    };
    var oldYear = function oldYear(e) {
      activeIndex.value = e;
      console.log();
      var s = newCode.value.Year + '/01/01 00:00:00';
      var t = newCode.value.Year + '/' + newCode.value.Moon + '/' + newCode.value.Day + ' ' + newCode.value.Time + ':' + '00';
      records(s, t, '');
      console.log(s, t);
    };
    var inputFunc = function inputFunc(e) {
      console.log(period);
      records('', '', period.value);
      fiveArray = [];
    };
    var records = function records() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      record({
        lottery_id: process.env.VUE_APP_TYPE_CODE,
        start_time: start,
        end_time: end,
        periods: period
      }).then(function (res) {
        var data = res.data.data;
        if (data.length == 0) {
          fiveArray.length = [];
        } else {
          fiveArray.length = [];
          fivedata.value = data[0];
          data.forEach(function (item, i) {
            fiveArray.push(item);
          });
          fiveArray.forEach(function (items) {
            items.open_number = items.open_number.split(',');
            items.sx = items.sx.split(',');
            items.color = items.color.split(',');
          });
        }
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(period) ? period.value = $event : period = $event;
        }),
        onInput: _cache[1] || (_cache[1] = function () {
          return _unref(inputFunc) && _unref(inputFunc).apply(void 0, arguments);
        }),
        placeholder: "輸入期號",
        maxlength: "11"
      }, null, 544), [[_vModelText, _unref(period)]]), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h3", null, [_createElementVNode("b", null, _toDisplayString(_unref(newCode).Year + _unref(newCode).Nq), 1), _createTextVNode(" 期截止時間： "), _createElementVNode("b", null, _toDisplayString(_unref(newCode).Year) + "-" + _toDisplayString(_unref(newCode).Moon) + "-" + _toDisplayString(_unref(newCode).Day) + " " + _toDisplayString(_unref(newCode).Time) + ":00", 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_12, _toDisplayString(_unref(hours)[0]), 1), _createElementVNode("li", _hoisted_13, _toDisplayString(_unref(hours)[1]), 1), _hoisted_14, _createElementVNode("li", _hoisted_15, _toDisplayString(_unref(minutes)[0]), 1), _createElementVNode("li", _hoisted_16, _toDisplayString(_unref(minutes)[1]), 1), _hoisted_17, _createElementVNode("li", _hoisted_18, _toDisplayString(_unref(seconds)[0]), 1), _createElementVNode("li", _hoisted_19, _toDisplayString(_unref(seconds)[1]), 1)])]), _hoisted_20])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("h3", _hoisted_23, [_hoisted_24, _createTextVNode("第 "), _createElementVNode("b", null, _toDisplayString(_unref(newCode).Year + _unref(newCode).Qi), 1), _createTextVNode(" 期"), _hoisted_25]), _createElementVNode("ul", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kajing), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": _normalizeClass(item.style),
          key: index
        }, [_createElementVNode("strong", null, _toDisplayString(item.number), 1), _createElementVNode("em", null, _toDisplayString(textChange(item.sx)), 1)], 2);
      }), 128))])])])])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("ul", _hoisted_29, [_createElementVNode("li", {
        "class": _normalizeClass(_unref(activeIndex) == '1' ? 'active' : ''),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _unref(newYear)(1);
        })
      }, "今年", 2), _createElementVNode("li", {
        "class": _normalizeClass(_unref(activeIndex) == '2' ? 'active' : ''),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _unref(oldYear)(2);
        })
      }, "去年", 2)]), _createElementVNode("div", _hoisted_30, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _isRef(period) ? period.value = $event : period = $event;
        }),
        onInput: _cache[5] || (_cache[5] = function () {
          return _unref(inputFunc) && _unref(inputFunc).apply(void 0, arguments);
        }),
        placeholder: "輸入期號",
        maxlength: "11"
      }, null, 544), [[_vModelText, _unref(period)]]), _hoisted_31])]), _createVNode(hisWrapper, {
        onVideoBack: _unref(videoBack),
        fiveArray: _unref(fiveArray)
      }, null, 8, ["onVideoBack", "fiveArray"])])]), _createVNode(plaues, {
        videoShow: _unref(videoShow),
        codeArray: _unref(codeArray),
        onPclose: _unref(pclose)
      }, null, 8, ["videoShow", "codeArray", "onPclose"])], 64);
    };
  }
};